import { FC } from "react";

import styled from "@mui/material/styles/styled";
import Typography, { TypographyProps } from "@mui/material/Typography";

import LoadSpinner from "@rui/LoadSpinner";
import Stack, { Column, Row } from "@rui/Stack";

export const IntegrationsPageContainer = styled(Stack)(({ theme }) => ({
  height: "100%",

  [theme.breakpoints.up("mobile")]: {
    maxHeight: "100vh",
  },
}));

export const IntegrationsContent = styled(Row)({
  height: "100%",
  width: "100%",
  maxWidth: "100%",
  overflow: "hidden",
});

export const IntegrationsSidebar = styled(Column)(({ theme }) => ({
  borderRight: "1px solid",
  borderColor: theme.palette.shades.neutral[100],
  width: "390px",
  minWidth: "390px",
  height: "100%",
  maxHeight: "100%",
  overflow: "hidden",
  backgroundColor: "#FFF",

  [theme.breakpoints.down("mobile")]: {
    width: "100%",
    minWidth: "100%",
  },
}));

export const ScrollableContent = styled(Column)(({ theme }) => ({
  flex: 1,
  height: "100%",
  overflowY: "auto",
  paddingBottom: theme.spacing(2),
}));

export const TabsContainer = styled(Stack)(({ theme }) => ({
  justifyContent: "center",
  padding: theme.spacing(0.5, 0.5, 0),
  borderBottom: "2px solid",
  borderColor: theme.palette.shades.neutral[100],
  "& .MuiTabs-root": {
    marginBottom: "-2px",
  },
  [theme.breakpoints.up("mobile")]: {
    padding: theme.spacing(0.5, 2, 0),
  },
}));

export const Detail = styled<FC<TypographyProps>>((props) => (
  <Typography variant="labelReg" {...props} />
))(({ theme }) => ({
  color: theme.palette.shades.neutral[500],
  backgroundColor: theme.palette.background.default,
  borderRadius: "4px",
  margin: theme.spacing(1, 1.5),
  padding: theme.spacing(1),
}));

export const IntegrationDetailContent = styled(Stack)(({ theme }) => ({
  flex: 1,
  padding: theme.spacing(3),
  overflowY: "auto",
}));

export const LoadingIntegrationDetail = () => (
  <Stack flex={1} variant="center">
    <LoadSpinner delay={1000} />
  </Stack>
);

export const List = styled("ul")({
  marginTop: 0,
  marginBottom: "8px",
  "& li": {
    paddingBottom: "4px",
  },
});
